import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mb-3 article-block" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "p-4" }
const _hoisted_4 = { class: "artist-card-img-wrap" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["href"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "intro-title genre-tag mt-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("rp", null, "/*", -1)
const _hoisted_10 = { class: "genre-trans" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("rp", null, "*/", -1)
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "album-intro-card" }
const _hoisted_15 = { class: "artist-name" }
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "rocknuts-title" }
const _hoisted_18 = { class: "auther-title" }
const _hoisted_19 = ["href"]
const _hoisted_20 = { class: "publish-time" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "style-list" }
const _hoisted_23 = { class: "badge badge-primary mb-2" }
const _hoisted_24 = {
  key: 0,
  class: "ml-2 hot-info-item"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-read text-gray" }, null, -1)
const _hoisted_26 = {
  key: 0,
  class: "read-more"
}
const _hoisted_27 = { key: 2 }
const _hoisted_28 = { class: "rocknuts-title" }
const _hoisted_29 = { class: "intro-title" }
const _hoisted_30 = { class: "auther-title" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "float-left" }
const _hoisted_33 = { class: "badge badge-primary mb-2" }
const _hoisted_34 = { class: "float-right" }
const _hoisted_35 = {
  key: 0,
  class: "hot-info-item"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-read text-gray" }, null, -1)
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { key: 2 }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-arrowdown" }, null, -1)
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-3" }, null, -1)
const _hoisted_42 = { key: 3 }
const _hoisted_43 = { class: "media" }
const _hoisted_44 = ["src"]
const _hoisted_45 = { class: "media-body" }
const _hoisted_46 = { class: "mt-0 artist-name" }
const _hoisted_47 = { class: "intro-title" }
const _hoisted_48 = ["href"]
const _hoisted_49 = { key: 0 }
const _hoisted_50 = {
  key: 0,
  class: "auther-title"
}
const _hoisted_51 = { class: "badge badge-primary mb-2" }
const _hoisted_52 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_UserTag = _resolveComponent("UserTag")!
  const _component_StyleTag = _resolveComponent("StyleTag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.full==2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.article.is_orig.index!=4)
                ? (_openBlock(), _createBlock(_component_RouterLink, {
                    key: 0,
                    to: { path: '/article/genrehis/'+_ctx.article._id }
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        class: "card-img",
                        src: _ctx.article.main_genre.primary_img,
                        alt: "artist image"
                      }, null, 8, _hoisted_5)
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: _ctx.article.url,
                    target: "_blank"
                  }, [
                    _createElementVNode("img", {
                      class: "card-img",
                      src: _ctx.article.main_genre.primary_img,
                      alt: "artist image"
                    }, null, 8, _hoisted_7)
                  ], 8, _hoisted_6))
            ]),
            _createElementVNode("h4", _hoisted_8, [
              _createElementVNode("ruby", null, [
                _createTextVNode(_toDisplayString(_ctx.article.main_genre.name) + " ", 1),
                _hoisted_9,
                _createElementVNode("rt", null, [
                  _createElementVNode("span", _hoisted_10, [
                    _createTextVNode(_toDisplayString(_ctx.article.main_genre.name_orig) + " ", 1),
                    (_ctx.article.main_genre.name_alt)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, "/ " + _toDisplayString(_ctx.article.main_genre.name_alt), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _hoisted_12
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.full==2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              (_ctx.article.is_orig.index!=4)
                ? (_openBlock(), _createBlock(_component_RouterLink, {
                    key: 0,
                    to: { path: '/article/genrehis/'+_ctx.article._id }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.article.title), 1)
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: _ctx.article.url,
                    target: "_blank"
                  }, " [转载] " + _toDisplayString(_ctx.article.title), 9, _hoisted_16))
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createTextVNode(" ["),
                (_ctx.article.url)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: _ctx.article.url,
                      target: "_blank"
                    }, "原链接", 8, _hoisted_19))
                  : _createCommentVNode("", true),
                _createTextVNode("] "),
                (_ctx.article.is_orig.index!=4)
                  ? (_openBlock(), _createBlock(_component_UserTag, {
                      key: 1,
                      user: _ctx.article.user_created,
                      full: 1
                    }, null, 8, ["user"]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_20, [
                  _createTextVNode(" [ " + _toDisplayString(_ctx.formatTS(_ctx.article.ts_updated)) + " ", 1),
                  (_ctx.article.ts_published>0 && _ctx.article.ts_updated!==_ctx.article.ts_published)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, "/ " + _toDisplayString(_ctx.formatTS(_ctx.article.ts_published)), 1))
                    : _createCommentVNode("", true),
                  _createTextVNode(" ] ")
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.article.styles, (style) => {
                return (_openBlock(), _createBlock(_component_StyleTag, {
                  key: style._id,
                  genre: style,
                  full: 0
                }, null, 8, ["genre"]))
              }), 128)),
              _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.article.type.name), 1),
              _createElementVNode("span", {
                class: _normalizeClass(["badge badge-danger mb-2", {'badge-danger':_ctx.article.is_orig.index!=1,'badge-success':_ctx.article.is_orig.index==1}])
              }, _toDisplayString(_ctx.article.is_orig.name), 3),
              (_ctx.article.counter_view>0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                    _hoisted_25,
                    _createTextVNode(" " + _toDisplayString(_ctx.article.counter_view), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.article.is_orig.index!=4)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createVNode(_component_RouterLink, {
                    to: { path: '/article/genrehis/'+_ctx.article._id }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Read More ")
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.full==1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_RouterLink, {
                to: { path: '/article/genrehis/'+_ctx.article._id }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.article.title), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_component_UserTag, {
                user: _ctx.article.user_created,
                full: 1
              }, null, 8, ["user"]),
              _createTextVNode(" [ " + _toDisplayString(_ctx.formatTS(_ctx.article.ts_updated)) + " ", 1),
              (_ctx.article.ts_updated!=_ctx.article.ts_published)
                ? (_openBlock(), _createElementBlock("span", _hoisted_31, "/ " + _toDisplayString(_ctx.formatTS(_ctx.article.ts_published)), 1))
                : _createCommentVNode("", true),
              _createTextVNode(" ] ")
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["expendable", {'is-expanded':_ctx.is_expanded}])
          }, [
            _createElementVNode("div", {
              class: "expand-icon text-right",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.expand && _ctx.expand(...args)))
            }, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.article.type.name), 1),
                _createElementVNode("span", {
                  class: _normalizeClass(["badge badge-danger mb-2", {'badge-danger':_ctx.article.is_orig.index!=1,'badge-success':_ctx.article.is_orig.index==1}])
                }, _toDisplayString(_ctx.article.is_orig.name), 3)
              ]),
              _createElementVNode("div", _hoisted_34, [
                (_ctx.article.counter_view>0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_35, [
                      _hoisted_36,
                      _createTextVNode(" " + _toDisplayString(_ctx.article.counter_view), 1)
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.is_expanded)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_37, "阅读"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_38, "收起")),
                _hoisted_39
              ])
            ]),
            _createElementVNode("div", {
              class: "info-holder",
              innerHTML: _ctx.markdown.render(_ctx.article.content)
            }, null, 8, _hoisted_40)
          ], 2),
          _hoisted_41
        ]))
      : _createCommentVNode("", true),
    (_ctx.full==0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("img", {
              src: _ctx.article.main_genre.primary_img,
              class: "align-self-start mr-3 img-fluid",
              style: {"width":"100px"}
            }, null, 8, _hoisted_44),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("h5", _hoisted_46, [
                _createVNode(_component_RouterLink, {
                  to: { path: '/article/genrehis/'+_ctx.article._id }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.article.main_genre.name_orig), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ]),
              _createElementVNode("div", _hoisted_47, [
                (_ctx.article.is_orig.index !=4)
                  ? (_openBlock(), _createBlock(_component_RouterLink, {
                      key: 0,
                      to: { path: '/article/rocknut/'+_ctx.article._id }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.article.title), 1)
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true),
                (_ctx.article.is_orig.index ==4)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: _ctx.article.url,
                      target: "_blank"
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.article.title) + " / ", 1),
                      (_ctx.article.auther)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(_ctx.article.auther), 1))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_48))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.article.is_orig.index!=4)
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.article.type.name), 1),
                    _createVNode(_component_UserTag, {
                      user: _ctx.article.user_created,
                      full: 1
                    }, null, 8, ["user"]),
                    _createTextVNode(" [ " + _toDisplayString(_ctx.formatTS(_ctx.article.ts_updated)) + " ", 1),
                    (_ctx.article.ts_updated!=_ctx.article.ts_published)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_52, "/ " + _toDisplayString(_ctx.formatTS(_ctx.article.ts_published)), 1))
                      : _createCommentVNode("", true),
                    _createTextVNode(" ] ")
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}